import { Release } from "../../models/release-fields";

export interface releaseState {
    releaseList: Release[];
    loading: boolean;
    error: string | null;
}

export const initialState : releaseState ={
    releaseList: [],
    loading: false,
    error: null
}